import { Component } from '@angular/core';

@Component({
  selector: 'rh-newsletter-confidental-note-dialog',
  templateUrl: './newsletter-confidental-note-dialog.container.html',
  styleUrls: ['./newsletter-confidental-note-dialog.container.scss']
})
export class NewsletterConfidentalNoteDialogContainer {}
